import moment from 'moment'
import React, { Component } from 'react'

export default class WebFooter extends Component {
  render() {
    return (
      <div class="webfooterdesktop">
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: "100%", marginRight: "-50%" }}>
          <span>Copyright © {moment().format("YYYY")} Universal Health Fellowship. All rights reserved. | Powered by CarynHealth</span>
        </div>
        <div>Version 5.1.0</div>
      </div>
    )
  }
}
